module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.component.type === 'tab') ? _c('div', _vm._l((_vm.component.children), function(subcomponent, index) {
    return _c('renderer-block', {
      key: ("subcomponent_" + index),
      attrs: {
        "component": subcomponent,
        "instance": _vm.instance
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'section') ? _c('FormSection', {
    attrs: {
      "label": _vm.component.label,
      "Index": _vm.component_name,
      "id": _vm.component_name
    }
  }, _vm._l((_vm.component.children), function(subcomponent, index) {
    return _c('renderer-block', {
      key: ("section_" + index),
      attrs: {
        "component": subcomponent,
        "instance": _vm.instance
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'group') ? _c('Group', {
    attrs: {
      "field_data": _vm.value,
      "label": _vm.component.label,
      "name": _vm.component_name,
      "id": _vm.element_id(),
      "help_text": _vm.help_text,
      "help_text_url": _vm.help_text_url,
      "isRemovable": true
    }
  }, _vm._l((_vm.component.children), function(subcomponent, index) {
    return _c('renderer-block', {
      key: ("group_" + index),
      attrs: {
        "component": subcomponent,
        "instance": _vm.instance
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'group2') ? _c('Group2', {
    attrs: {
      "field_data": _vm.value,
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "component": _vm.component,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'richtext') ? _c('RichTextField', {
    attrs: {
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "can_view_richtext_src": _vm.can_view_richtext_src,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'text') ? _c('TextField', {
    attrs: {
      "type": "text",
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'string') ? _c('TextField', {
    attrs: {
      "type": "string",
      "name": _vm.component.name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'number') ? _c('TextField', {
    attrs: {
      "type": "number",
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "min": _vm.component.min,
      "max": _vm.component.max,
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'email') ? _c('TextField', {
    attrs: {
      "type": "email",
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'select') ? _c('div', [_c('SelectBlock', {
    attrs: {
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "options": _vm.component.options,
      "help_text": _vm.help_text,
      "handleChange": _vm.handleComponentChange(_vm.component, true),
      "conditions": _vm.component.conditions,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }), _vm._v(" "), _c('Conditions', {
    attrs: {
      "conditions": _vm.component.conditions,
      "name": _vm.component_name,
      "instance": _vm.instance,
      "data": _vm.json_data,
      "id": _vm.element_id(1),
      "readonly": _vm.is_readonly
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'multi-select') ? _c('SelectBlock', {
    attrs: {
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "options": _vm.component.options,
      "help_text": _vm.help_text,
      "handleChange": _vm.handleComponentChange(_vm.component, false),
      "readonly": _vm.is_readonly,
      "isMultiple": true,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'text_area') ? _c('TextAreaBlock', {
    attrs: {
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'table') ? _c('TableBlock', {
    attrs: {
      "headers": _vm.component.headers,
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'expander_table') ? _c('ExpanderTable', {
    attrs: {
      "field_data": _vm.value,
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "component": _vm.component,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'label') ? _c('LabelBlock', {
    attrs: {
      "value": _vm.component.label,
      "id": _vm.element_id(),
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'radiobuttons') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "inline",
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.element_id()
    }
  }, [_vm._v(_vm._s(_vm.component.label) + " "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })], 1), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.component.label,
      "name": _vm.component_name,
      "field_data": _vm.value
    }
  }), _vm._v(" "), _vm._l((_vm.component.options), function(option, index) {
    return _c('Radio', {
      key: ("radio_" + _vm.component_name + "_" + index),
      attrs: {
        "name": _vm.component_name,
        "label": option.label,
        "value": option.value,
        "isRequired": option.isRequired || _vm.component.isRequired,
        "id": _vm.element_id(1),
        "savedValue": _vm.value,
        "handleChange": _vm.handleComponentChange(_vm.component),
        "conditions": _vm.component.conditions,
        "readonly": _vm.is_readonly
      }
    })
  }), _vm._v(" "), _c('Conditions', {
    attrs: {
      "conditions": _vm.component.conditions,
      "name": _vm.component_name,
      "instance": _vm.instance,
      "data": _vm.json_data,
      "id": _vm.element_id(2),
      "readonly": _vm.is_readonly
    }
  })], 2) : _vm._e(), _vm._v(" "), (_vm.component.type === 'checkbox') ? _c('div', {
    staticClass: "form-group"
  }, [_c('Checkbox', {
    attrs: {
      "group": _vm.component.group,
      "name": _vm.component_name,
      "label": _vm.component.label,
      "id": _vm.element_id(1),
      "help_text": _vm.help_text,
      "help_text_url": _vm.help_text_url,
      "field_data": _vm.value,
      "handleChange": _vm.handleComponentChange(_vm.component),
      "conditions": _vm.component.conditions,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired
    }
  }), _vm._v(" "), _c('Conditions', {
    attrs: {
      "conditions": _vm.component.conditions,
      "name": _vm.component_name,
      "instance": _vm.instance,
      "data": _vm.json_data,
      "id": _vm.element_id(2),
      "isRequired": _vm.component.isRequired
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'declaration') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.component.label))]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "help_text": _vm.component.help_text,
      "handleChange": _vm.handleComponentChange(_vm.component),
      "conditions": _vm.component.conditions
    }
  }), _vm._v(" "), _c('Conditions', {
    attrs: {
      "conditions": _vm.component.conditions,
      "name": _vm.component_name,
      "instance": _vm.instance,
      "data": _vm.value
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'file') ? _c('File', {
    attrs: {
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "isRepeatable": _vm.strToBool(_vm.component.isRepeatable),
      "readonly": _vm.is_readonly,
      "help_text": _vm.help_text,
      "docsUrl": _vm.documents_url,
      "application_id": _vm.application_id,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url,
      "isTableField": _vm.isTableField
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'date') ? _c('DateField', {
    attrs: {
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "readonly": _vm.is_readonly,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url,
      "isTableField": _vm.isTableField
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'grid') ? _c('GridBlock', {
    attrs: {
      "name": _vm.component.name,
      "headers": _vm.component.headers,
      "field_data": _vm.component.data,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'species') ? _c('Species', {
    attrs: {
      "name": _vm.component.name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "options": _vm.component.component_attribute,
      "isMultiple": true,
      "isRepeatable": _vm.strToBool(_vm.component.isRepeatable),
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "handleChange": _vm.handleComponentChange(_vm.component, true),
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'species-group') ? _c('SpeciesGroup', {
    attrs: {
      "label": _vm.component.label,
      "name": _vm.component_name,
      "id": _vm.element_id(),
      "help_text": _vm.help_text,
      "help_text_url": _vm.help_text_url,
      "isRemovable": true
    }
  }, _vm._l((_vm.component.children), function(subcomponent, index) {
    return _c('renderer-block', {
      key: ("species-group_" + index),
      attrs: {
        "component": subcomponent,
        "instance": _vm.instance
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'species-all') ? _c('SpeciesFiltered', {
    attrs: {
      "name": _vm.component.name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "options": _vm.component.component_attribute,
      "isMultiple": false,
      "isRepeatable": _vm.strToBool(_vm.component.isRepeatable),
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "handleChange": _vm.handleComponentChange(_vm.component, true),
      "help_text_url": _vm.help_text_url,
      "filtered_list_url": _vm.application_url(_vm.component)
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e337ced2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/renderer_block.vue
// module id = 1060
// module chunks = 0